import { render, staticRenderFns } from "./PublishSharedLink.vue?vue&type=template&id=09197e29&scoped=true"
import script from "./PublishSharedLink.vue?vue&type=script&lang=ts"
export * from "./PublishSharedLink.vue?vue&type=script&lang=ts"
import style0 from "./PublishSharedLink.vue?vue&type=style&index=0&id=09197e29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09197e29",
  null
  
)

export default component.exports